export default "__VITE_ASSET__bdc79281__"